export default
    {
        guardaCotiza: "/imagen/guardaCotiza",
        guardaSolicitudEstudio: "/imagen/guardaSolicitudEstudio",
        listEstudios: "/imagen/listEstudios",
        listItemEstudio: "/imagen/listItemsEstudio",
        updateItemEstudio: "/imagen/updateItemsEstudio",
        catalogoEstudios: "/catalogos/catalogoEstudiosRx",
    }
